import React from 'react';
import { useParams } from 'react-router-dom';
import SportEvents from './SportEvents';
import CoachSportEvents from './CoachSportEvents';

export default function index() {
  const params = useParams();
  return <div>{params.user === 'athlete' ? <SportEvents /> : <CoachSportEvents />}</div>;
}
